'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Image,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { Button, Thead, Th, Grid, IconButton, Tooltip } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import {
   clearCacheReport,
   deleteReportFormat,
   getReportFormat,
   getReportOutstandingDetail,
} from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon, ViewIcon } from '@chakra-ui/icons';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice, getSingleWithPrevAndNext } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice, getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById, getAccount } from '../../../../redux/actions/account';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import AccountingReportsFilter from '../components/AccountingReportsFilter';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import { getShareCompanyOptions } from 'utils/util';
import { REPORT_TYPE } from 'constants';
import { osTypeOptions } from 'constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import { motion } from 'framer-motion';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdDelete, MdExpand, MdOutlineRefresh } from 'react-icons/md';
import { useGlobal, useUser } from 'contexts';
import { IoFilterOutline } from 'react-icons/io5';
import ColumnShowHide from '../components/Columnshowhide';
import { FiPlusCircle } from 'react-icons/fi';
import { LucideEdit } from 'lucide-react';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const Outstanding = () => {
   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);
   const columnHelper = createColumnHelper();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [fromDate, setFromDate] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [reportType, setReportType] = useState(REPORT_TYPE.party);
   const [osType, setOsType] = useState(osTypeOptions[0].value);
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState('');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const dbName = localStorage.getItem('dbName');
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [editData, setEditData] = useState({});
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [showHideData, setShowHideData] = useState({});
   const { companyList } = useGlobal();
   const { user } = useUser();
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const isStaticReportType = ['date', 'party', 'broker'].includes(reportType);
   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else if (entityType === 'cash') {
         return state.voucher?.single || {};
      } else if (entityType === 'bank') {
         return state.voucher?.single || {};
      } else {
         return {};
      }
   });
   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),

      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),

      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

      docNumber: Yup.string().required('Document number is required'),

      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),

      txnType: Yup.number().required('Transaction type is required'),
   });
   const accountData = useSelector((state) => state.account.list);
   const singleVoucher = useSelector((state) => state.voucher?.single || null);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendIdInAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [dataId, setDataId] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      // pendingAmt: 0,
      outAdjustments: [],
   });
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const cashReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashReceive
      : null;

   const cashPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashPayment
      : null;

   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;

   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
               ? viewDatasr?.data[0]
               : entityType === 'saleinvoice'
                  ? viewDatasi
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi
                     : null;

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
               ? viewDatasr?.pagination
               : entityType === 'saleinvoice'
                  ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi?.pagination
                     : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);

   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   const allowedDefNames = ['OutstandingDate', 'OutstandingParty', 'OutstandingBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));

   const staticReportTypeOptions = [
      { value: 'date', label: 'Date' },
      { value: 'party', label: 'Party' },
      { value: 'broker', label: 'Broker' },
   ];

   const reportTypeOptions = [
      ...staticReportTypeOptions,
      ...(dynamicOptions.length > 0
         ? [
            {
               label: 'Custom Formats',
               options: dynamicOptions,
            },
         ]
         : []),
   ];

   // Define columns for the outstanding report
   const columnsReportsSalesDetail = useCallback((dynamicOptionValues, isStaticReportType, textColor) => {
      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         // First try to find by defName, then by title
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            // Return default values if no customization found or for static report types
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         {
            id: 'txndate',
            header: 'Date',
            accessor: 'txndate',
            isShow: getColumnInfo('date').isShow,
            color: getColumnInfo('date').color,
            isBold: getColumnInfo('date').isBold,
            isItalic: getColumnInfo('date').isItalic,
            orderNo: getColumnInfo('date').orderNo,
            flex: getColumnInfo('date').flex,
         },
         {
            id: 'docnumber',
            header: 'V.No.',
            accessor: 'docnumber',
            isShow: getColumnInfo('docnumber').isShow,
            color: getColumnInfo('docnumber').color,
            isBold: getColumnInfo('docnumber').isBold,
            isItalic: getColumnInfo('docnumber').isItalic,
            orderNo: getColumnInfo('docnumber').orderNo,
            flex: getColumnInfo('docnumber').flex,
         },
         {
            id: 'dueDays',
            header: 'Due Days',
            accessor: 'dueDays',
            isShow: getColumnInfo('dueDays').isShow,
            color: getColumnInfo('dueDays').color,
            isBold: getColumnInfo('dueDays').isBold,
            isItalic: getColumnInfo('dueDays').isItalic,
            orderNo: getColumnInfo('dueDays').orderNo,
            flex: getColumnInfo('dueDays').flex,
         },
         {
            id: 'txndays',
            header: 'Txn Days',
            accessor: 'txndays',
            isShow: getColumnInfo('txndays').isShow,
            color: getColumnInfo('txndays').color,
            isBold: getColumnInfo('txndays').isBold,
            isItalic: getColumnInfo('txndays').isItalic,
            orderNo: getColumnInfo('txndays').orderNo,
            flex: getColumnInfo('txndays').flex,
         },
         {
            id: 'netAmount',
            header: 'Net Amount',
            accessor: 'netAmount',
            isShow: getColumnInfo('netAmount').isShow,
            color: getColumnInfo('netAmount').color,
            isBold: getColumnInfo('netAmount').isBold,
            isItalic: getColumnInfo('netAmount').isItalic,
            orderNo: getColumnInfo('netAmount').orderNo,
            flex: getColumnInfo('netAmount').flex,
         },
         {
            id: 'adjtxndate',
            header: 'Rec. Date',
            accessor: 'adjtxndate',
            isShow: getColumnInfo('adjtxndate').isShow,
            color: getColumnInfo('adjtxndate').color,
            isBold: getColumnInfo('adjtxndate').isBold,
            isItalic: getColumnInfo('adjtxndate').isItalic,
            orderNo: getColumnInfo('adjtxndate').orderNo,
            flex: getColumnInfo('adjtxndate').flex,
         },
         {
            id: 'adjdaybookname',
            header: 'Rec. Book',
            accessor: 'adjdaybookname',
            isShow: getColumnInfo('adjdaybookname').isShow,
            color: getColumnInfo('adjdaybookname').color,
            isBold: getColumnInfo('adjdaybookname').isBold,
            isItalic: getColumnInfo('adjdaybookname').isItalic,
            orderNo: getColumnInfo('adjdaybookname').orderNo,
            flex: getColumnInfo('adjdaybookname').flex,
         },
         {
            id: 'returnadjamount',
            header: 'Ret. Adj. Amt.',
            accessor: 'returnadjamount',
            isShow: getColumnInfo('returnadjamount').isShow,
            color: getColumnInfo('returnadjamount').color,
            isBold: getColumnInfo('returnadjamount').isBold,
            isItalic: getColumnInfo('returnadjamount').isItalic,
            orderNo: getColumnInfo('returnadjamount').orderNo,
            flex: getColumnInfo('returnadjamount').flex,
         },
         {
            id: 'otheradjamount',
            header: 'Adj. Amt.',
            accessor: 'otheradjamount',
            isShow: getColumnInfo('otheradjamount').isShow,
            color: getColumnInfo('otheradjamount').color,
            isBold: getColumnInfo('otheradjamount').isBold,
            isItalic: getColumnInfo('otheradjamount').isItalic,
            orderNo: getColumnInfo('otheradjamount').orderNo,
            flex: getColumnInfo('otheradjamount').flex,
         },
         {
            id: 'balanceamount',
            header: 'OS. Amt',
            accessor: 'balanceamount',
            isShow: getColumnInfo('balanceamount').isShow,
            color: getColumnInfo('balanceamount').color,
            isBold: getColumnInfo('balanceamount').isBold,
            isItalic: getColumnInfo('balanceamount').isItalic,
            orderNo: getColumnInfo('balanceamount').orderNo,
            flex: getColumnInfo('balanceamount').flex,
         },
      ];

      return baseColumns
         .filter((col) => col.isShow !== false)
         .sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });
   });

   const dynamicValues = dynamicOptions.map((option) => option.value);
   const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;

   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const dynamicColumns = useMemo(() => {
      const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
      return columnsReportsSalesDetail(reportType, format);
   }, [reportType, reportformat]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width, // default width if not defined
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ff4d4f',
                  padding: '0 5px',
               }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const handleDeleteFormat = async (id) => {
      try {
         // Call the action creator
         await dispatch(deleteReportFormat(id));

         // Reset edit state if this was the currently edited format
         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         // Errors are already handled in the action creator
         console.error('Delete error:', error);
      }
   };

   const handleReportTypeChange = (selectedOption) => {
      setReportType(selectedOption.value);
      setExpandedItems({});
      dispatch(getReportFormat());
   };

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   const columns = useMemo(
      () =>
         dynamicColumns.map((column) =>
            columnHelper.accessor(column.id, {
               id: column.id,
               header: () => (
                  <Text
                     justifyContent="space-between"
                     align="center"
                     fontSize={{ sm: '10px', lg: '12px' }}
                     color={textColor}>
                     {column.header}
                  </Text>
               ),
               cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
            }),
         ),
      [columnHelper, dynamicColumns, textColor],
   );

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   const fetchData = useCallback(async () => {
      setIsLoading(true);
      try {
         const storedCompanyId = parseInt(localStorage.getItem('companyId'), 10);
         const fallbackCompanyId = Number.isInteger(storedCompanyId) ? [storedCompanyId] : [];
         const companyIds = companyFilter.length > 0 ? companyFilter : fallbackCompanyId;

         if (!datePartyWiseSalesRange?.fromDate || !datePartyWiseSalesRange?.toDate || companyIds.length === 0) {
            console.warn('Missing required parameters for API call');
            return;
         }

         await dispatch(
            getReportOutstandingDetail({
               companyIds: companyIds.join(','),
               isPurchaseOs: osType,
               fromDate: datePartyWiseSalesRange.fromDate,
               toDate: datePartyWiseSalesRange.toDate,
               search: debouncedSearchQuery,
            }),
         );
      } catch (error) {
         console.error('Error fetching outstanding details:', error);
      } finally {
         setIsLoading(false);
      }
   }, [dispatch, companyFilter, datePartyWiseSalesRange, osType, debouncedSearchQuery]);

   useEffect(() => {
      dispatch(clearCacheReport());
      const timer = setTimeout(fetchData, 300);
      return () => clearTimeout(timer);
   }, [fetchData, dispatch]);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   }, []);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   const handleSearchChange = useCallback(
      (e) => {
         const value = e.target.value;
         setSearchQuery(value);
         debouncedSearchHandler(value);
      },
      [debouncedSearchHandler],
   );

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const handleRefresh = useCallback(() => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];
      try {
         if (fromDate && toDate && companyIds.length > 0) {
            dispatch(
               getReportOutstandingDetail({
                  companyIds: companyIds.toString(),
                  isPurchaseOs: osType,
                  fromDate: fromDate,
                  toDate: toDate,
                  search: debouncedSearchQuery,
               }),
            );
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   }, [dispatch, companyFilter, fromDate, toDate, osType, debouncedSearchQuery]);

   const handleNextPage = () => {
      // console.log('Next');
   };
   const handlePrevPage = () => {
      // console.log('Prev');
   };

   const salesReport = useSelector((state) => state.reports?.outstanding || []);
   const { isOpen, onOpen, onClose } = useDisclosure();

   const table = useReactTable({
      data: salesReport,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const toggleExpand = (id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   };

   const expandAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         companyData.data?.forEach((accountData) => {
            const accountKey = `account-${accountData.accountId}`;
            newExpanded[accountKey] = true;
         });
      });
      setExpandedItems(newExpanded);
   }, [salesReport]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = false;

         companyData.data?.forEach((accountData) => {
            const accountKey = `account-${accountData.accountId}`;
            newExpanded[accountKey] = false;
         });
      });
      setExpandedItems(newExpanded);
   }, [salesReport]);

   const formatDataForExport = useCallback((salesReport) => {
      const flattenedData = [];
      salesReport.forEach((companyData) => {
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               if (accountData.data && Array.isArray(accountData.data)) {
                  accountData.data.forEach((transaction) => {
                     flattenedData.push({
                        Date: transaction.txndate ? new Date(transaction.txndate).toLocaleDateString('en-IN') : '',
                        'V.No.': transaction.docnumber || '',
                        'Due Days': transaction.dueDays != null ? transaction.dueDays : '',
                        'Net Amount': transaction.netAmount != null ? Number(transaction.netAmount) : '',
                        'Rec. Date': transaction.adjtxndate
                           ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN')
                           : '',
                        'Rec. Book': transaction.adjdaybookname || '',
                        'Ret. Adj. Amt.':
                           transaction.returnadjamount != null ? Number(transaction.returnadjamount) : '',
                        'Adj. Amt.': transaction.otheradjamount != null ? Number(transaction.otheradjamount) : '',
                        'OS. Amt': transaction.balanceamount != null ? Number(transaction.balanceamount) : '',
                     });
                  });
               }
            });
         }
      });
      return flattenedData;
   }, []);

   const downloadAsExcel = useCallback(() => {
      const data = formatDataForExport(salesReport);
      if (data.length === 0) {
         alert('No data available to download.');
         return;
      }

      // Import the library
      const XLSX = require('xlsx-js-style');

      // Create workbook
      const wb = XLSX.utils.book_new();

      // Determine if this is a dynamic format
      let isDynamicFormat = false;
      let formatData = null;
      let visibleColumns = [];

      // Check if reportType exists in dynamicOptions
      if (dynamicOptions && Array.isArray(dynamicOptions)) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         if (selectedFormat && selectedFormat.formatData) {
            isDynamicFormat = true;
            formatData = selectedFormat.formatData;
         }
      }

      if (isDynamicFormat && formatData?.viewJson) {
         // Dynamic format logic
         visibleColumns = formatData.viewJson
            .filter((item) => item.isShow === true || item.isShow === 'true')
            .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));
      } else {
         // Static format logic
         const staticColumns = columnsReportsSalesDetail(null, true, textColor || '#000000');
         visibleColumns = staticColumns.filter((col) => {
            return columnVisibility && columnVisibility[col.id] !== false;
         });
      }

      if (!visibleColumns || visibleColumns.length === 0) {
         alert('No columns available for Excel generation. Please check your column settings.');
         return;
      }

      // Helper function to convert backend color format to hex for Excel
      const convertBackendColorToHex = (backendColor) => {
         if (!backendColor) return '000000';
         if (backendColor.startsWith('#')) {
            return backendColor.substring(1);
         }
         if (backendColor.startsWith('0xff')) {
            return backendColor.substring(4);
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            return backendColor;
         }
         return '000000';
      };

      // Helper function to get column styling for dynamic format
      const getColumnStyles = (columnDefName) => {
         if (!isDynamicFormat || !formatData?.viewJson) {
            return {
               font: { color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            };
         }

         const viewItem = formatData.viewJson.find((item) => item.defName === columnDefName);

         const styles = {
            font: {
               color: { rgb: viewItem?.color ? convertBackendColorToHex(viewItem.color) : '000000' },
            },
            alignment: { horizontal: 'left' },
         };

         if (viewItem?.isBold === true || viewItem?.isBold === 'true') {
            styles.font.bold = true;
         }

         if (viewItem?.isItalic === true || viewItem?.isItalic === 'true') {
            styles.font.italic = true;
         }

         return styles;
      };

      // Define base styles
      const headerStyle = {
         font: { bold: true, color: { rgb: '000000' } },
         fill: { fgColor: { rgb: 'F5F5F5' } },
         alignment: { horizontal: 'center' },
         border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
         },
      };

      const companyStyle = {
         font: { bold: true, color: { rgb: '7D1214' } },
         fill: { fgColor: { rgb: 'E6E6E6' } },
         alignment: { horizontal: 'left' },
      };

      const partyStyle = {
         font: { bold: true, color: { rgb: '2A3335' } },
         fill: { fgColor: { rgb: 'F6F0F0' } },
         alignment: { horizontal: 'left' },
      };

      const oddRowStyle = { fill: { fgColor: { rgb: 'E6F2FF' } } };
      const evenRowStyle = { fill: { fgColor: { rgb: 'FFFFFF' } } };

      const numericStyle = {
         alignment: { horizontal: 'right' },
         numFmt: '#,##0.00',
      };

      const totalStyle = {
         font: { bold: true, color: { rgb: '7D1214' } },
         fill: { fgColor: { rgb: 'E6E6E6' } },
         alignment: { horizontal: 'right' },
      };

      // Helper function to get cell value based on column configuration
      const getCellValue = (transaction, column) => {
         if (isDynamicFormat) {
            // Dynamic format - use field mapping
            const fieldMapping = {
               date: 'txndate',
               'v.no.': 'docnumber',
               due_days: 'dueDays',
               net_amount: 'netAmount',
               'rec._date': 'adjtxndate',
               'rec._book': 'adjdaybookname',
               'ret._adj._amt.': 'returnadjamount',
               'adj._amt.': 'otheradjamount',
               'os._amt': 'balanceamount',
            };

            const fieldId = fieldMapping[column.defName] || column.defName;
            return getCellValueByFieldId(transaction, fieldId);
         } else {
            // Static format - use column id directly
            return getCellValueByFieldId(transaction, column.id);
         }
      };

      // Helper function to get cell value by field ID
      const getCellValueByFieldId = (transaction, fieldId) => {
         switch (fieldId) {
            case 'txndate':
               return transaction.txndate ? new Date(transaction.txndate).toLocaleDateString('en-IN') : '';
            case 'docnumber':
               return transaction.docnumber || '';
            case 'dueDays':
               return transaction.dueDays || '';
            case 'netAmount':
               return transaction.netAmount != null ? Number(transaction.netAmount) : '';
            case 'adjtxndate':
               return transaction.adjtxndate ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN') : '';
            case 'adjdaybookname':
               return transaction.adjdaybookname || '';
            case 'returnadjamount':
               return transaction.returnadjamount != null ? Number(transaction.returnadjamount) : '';
            case 'otheradjamount':
               return transaction.otheradjamount != null ? Number(transaction.otheradjamount) : '';
            case 'balanceamount':
               return transaction.balanceamount != null ? Number(transaction.balanceamount) : '';
            default:
               return transaction[fieldId] || '';
         }
      };

      // Helper function to determine if a field is numeric
      const isNumericField = (column) => {
         const numericFields = ['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount', 'dueDays'];

         if (isDynamicFormat) {
            const fieldMapping = {
               due_days: 'dueDays',
               net_amount: 'netAmount',
               'ret._adj._amt.': 'returnadjamount',
               'adj._amt.': 'otheradjamount',
               'os._amt': 'balanceamount',
            };
            const fieldId = fieldMapping[column.defName] || column.defName;
            return numericFields.includes(fieldId);
         } else {
            return numericFields.includes(column.id);
         }
      };

      // Helper function to get column header
      const getColumnHeader = (column) => {
         if (isDynamicFormat) {
            return column.title || column.defName;
         } else {
            return column.header;
         }
      };

      // Prepare the worksheet data
      const wsData = [];

      // Add header row
      const headerRow = visibleColumns.map((column) => ({
         v: getColumnHeader(column),
         t: 's',
         s: headerStyle,
      }));
      wsData.push(headerRow);

      // Track current row for styling and merges
      let currentRow = 1; // Header is row 0
      const merges = [];

      salesReport.forEach((companyData) => {
         // Add company row (fill all columns with styled cells)
         const companyRow = visibleColumns.map((column, index) => ({
            v: index === 0 ? companyData.companyName : '',
            t: 's',
            s: companyStyle,
         }));
         wsData.push(companyRow);

         // Add merge for company row (span all columns)
         if (visibleColumns.length > 1) {
            merges.push({
               s: { r: currentRow, c: 0 },
               e: { r: currentRow, c: visibleColumns.length - 1 },
            });
         }
         currentRow++;

         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               // Add party row (fill all columns with styled cells)
               const partyRow = visibleColumns.map((column, index) => ({
                  v: index === 0 ? `Party: ${accountData.accountName}` : '',
                  t: 's',
                  s: partyStyle,
               }));
               wsData.push(partyRow);

               // Add merge for party row (span all columns)
               if (visibleColumns.length > 1) {
                  merges.push({
                     s: { r: currentRow, c: 0 },
                     e: { r: currentRow, c: visibleColumns.length - 1 },
                  });
               }
               currentRow++;

               if (accountData.data && Array.isArray(accountData.data)) {
                  // Add transactions
                  accountData.data.forEach((transaction, idx) => {
                     const rowStyle = idx % 2 === 0 ? evenRowStyle : oddRowStyle;

                     const transactionRow = visibleColumns.map((column) => {
                        const value = getCellValue(transaction, column);
                        const isNumeric = isNumericField(column);
                        const columnStyles = isDynamicFormat ? getColumnStyles(column.defName) : {};

                        let cellStyle = { ...rowStyle, ...columnStyles };

                        if (isNumeric && value !== '' && value !== null && value !== undefined) {
                           cellStyle = { ...cellStyle, ...numericStyle };
                           return {
                              v: value,
                              t: 'n',
                              s: cellStyle,
                           };
                        } else {
                           return {
                              v: value,
                              t: 's',
                              s: cellStyle,
                           };
                        }
                     });

                     wsData.push(transactionRow);
                     currentRow++;
                  });

                  // Calculate and add party total
                  const uniqueTransactions = accountData.data.filter(
                     (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                  );

                  // Calculate totals for all numeric columns
                  const totals = {};
                  visibleColumns.forEach((column) => {
                     if (isNumericField(column)) {
                        const fieldId = isDynamicFormat
                           ? {
                              due_days: 'dueDays',
                              net_amount: 'netAmount',
                              'ret._adj._amt.': 'returnadjamount',
                              'adj._amt.': 'otheradjamount',
                              'os._amt': 'balanceamount',
                           }[column.defName] || column.defName
                           : column.id;

                        if (fieldId === 'netAmount' || fieldId === 'balanceamount') {
                           totals[fieldId] = uniqueTransactions.reduce(
                              (sum, item) => sum + (Number(item[fieldId]) || 0),
                              0,
                           );
                        } else {
                           totals[fieldId] = accountData.data.reduce(
                              (sum, item) => sum + (Number(item[fieldId]) || 0),
                              0,
                           );
                        }
                     }
                  });

                  // Add total row
                  const totalRow = visibleColumns.map((column, index) => {
                     if (index === 0) {
                        return {
                           v: 'Total:',
                           t: 's',
                           s: { ...totalStyle, alignment: { horizontal: 'left' } },
                        };
                     } else if (isNumericField(column)) {
                        const fieldId = isDynamicFormat
                           ? {
                              due_days: 'dueDays',
                              net_amount: 'netAmount',
                              'ret._adj._amt.': 'returnadjamount',
                              'adj._amt.': 'otheradjamount',
                              'os._amt': 'balanceamount',
                           }[column.defName] || column.defName
                           : column.id;

                        const totalValue = totals[fieldId];
                        if (totalValue !== undefined) {
                           return {
                              v: totalValue,
                              t: 'n',
                              s: { ...totalStyle, ...numericStyle },
                           };
                        }
                     }

                     return {
                        v: '',
                        t: 's',
                        s: totalStyle,
                     };
                  });

                  wsData.push(totalRow);
                  currentRow++;
               }
            });
         }
      });

      // Create worksheet with data
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Add merges to worksheet
      ws['!merges'] = merges;

      // Calculate dynamic column widths
      let columnWidths = [];

      if (isDynamicFormat && formatData?.viewJson) {
         // For dynamic format, use flex values to determine relative widths
         const totalFlex = visibleColumns.reduce((sum, col) => sum + (parseInt(col.flex) || 1), 0);
         const baseWidth = 200; // Base total width to distribute

         visibleColumns.forEach((column) => {
            const flexRatio = (parseInt(column.flex) || 1) / totalFlex;
            const width = Math.max(10, Math.floor(baseWidth * flexRatio) / 5); // Convert to approximate character width
            columnWidths.push({ wch: width });
         });
      } else {
         // For static format, use predefined widths
         visibleColumns.forEach((column) => {
            let width;
            switch (column.id) {
               case 'txndate':
                  width = 12;
                  break;
               case 'docnumber':
                  width = 10;
                  break;
               case 'dueDays':
                  width = 10;
                  break;
               case 'netAmount':
                  width = 15;
                  break;
               case 'adjtxndate':
                  width = 12;
                  break;
               case 'adjdaybookname':
                  width = 20;
                  break;
               case 'returnadjamount':
                  width = 15;
                  break;
               case 'otheradjamount':
                  width = 15;
                  break;
               case 'balanceamount':
                  width = 15;
                  break;
               default:
                  width = 15;
            }
            columnWidths.push({ wch: width });
         });
      }

      // Calculate maximum company and party name lengths for dynamic adjustment of first column
      let maxCompanyNameLength = 0;
      let maxPartyNameLength = 0;

      salesReport.forEach((companyData) => {
         if (companyData.companyName) {
            maxCompanyNameLength = Math.max(maxCompanyNameLength, companyData.companyName.length);
         }
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData) => {
               if (accountData.accountName) {
                  maxPartyNameLength = Math.max(maxPartyNameLength, `Party: ${accountData.accountName}`.length);
               }
            });
         }
      });

      // Ensure first column is wide enough for company/party names
      const firstColumnMinWidth = Math.max(20, maxCompanyNameLength + 5, maxPartyNameLength + 5) / 5;
      if (columnWidths[0] && columnWidths[0].wch < firstColumnMinWidth) {
         columnWidths[0].wch = firstColumnMinWidth;
      }

      // Set column widths
      ws['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Outstanding Report');

      // Generate Excel file
      XLSX.writeFile(wb, 'outstanding_report.xlsx');
   }, [
      formatDataForExport,
      salesReport,
      dynamicOptions,
      reportType,
      columnsReportsSalesDetail,
      textColor,
      columnVisibility,
   ]);

   const handleDownloadPDF = useCallback(() => {
      const doc = new jsPDF('landscape');
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 10; // Reduced margin
      let currentY = 10; // Start closer to top

      // Set default font with smaller size
      doc.setFont('helvetica');
      doc.setFontSize(8); // Set default font size to 8

      // Title
      doc.setFontSize(10); // Slightly larger for title but still small
      doc.setTextColor(0, 0, 0);

      // Center title
      const title = 'Outstanding Report';
      const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, currentY);
      currentY += 4; // Reduced spacing

      // Date range
      doc.setFontSize(8);
      const dateText = `Date Range: ${datePartyWiseSalesRange?.fromDate || ''} to ${datePartyWiseSalesRange?.toDate || ''
         }`;
      const dateWidth = (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const dateX = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateX, currentY);
      currentY += 3; // Reduced spacing

      // Company filter
      const selectedCompanies = companyFilter
         .map((id) => companyList.find((c) => c.id === id)?.name)
         .filter(Boolean)
         .join(', ');

      if (selectedCompanies) {
         const companyText = `Company: ${selectedCompanies}`;
         const companyWidth =
            (doc.getStringUnitWidth(companyText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const companyX = (pageWidth - companyWidth) / 2;
         doc.text(companyText, companyX, currentY);
         currentY += 4; // Reduced spacing
      }

      // Determine if this is a dynamic format
      let isDynamicFormat = false;
      let formatData = null;
      let visibleColumns = [];

      // Check if reportType exists in dynamicOptions
      if (dynamicOptions && Array.isArray(dynamicOptions)) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         if (selectedFormat && selectedFormat.formatData) {
            isDynamicFormat = true;
            formatData = selectedFormat.formatData;
         }
      }

      if (isDynamicFormat && formatData?.viewJson) {
         // Dynamic format logic
         visibleColumns = formatData.viewJson.filter((item) => item.isShow === true || item.isShow === 'true');
      } else {
         // Static format logic
         const staticColumns = columnsReportsSalesDetail(null, true, textColor || '#000000');
         visibleColumns = staticColumns.filter((col) => {
            return columnVisibility && columnVisibility[col.id] !== false;
         });
      }

      if (!visibleColumns || visibleColumns.length === 0) {
         alert('No columns available for PDF generation. Please check your column settings.');
         return;
      }

      // Helper function to convert backend color format to hex
      const convertBackendColor = (backendColor) => {
         if (!backendColor) return [0, 0, 0];
         if (backendColor.startsWith('#')) {
            const hex = backendColor.substring(1);
            return [
               parseInt(hex.substring(0, 2), 16),
               parseInt(hex.substring(2, 4), 16),
               parseInt(hex.substring(4, 6), 16),
            ];
         }
         if (backendColor.startsWith('0xff')) {
            const hex = backendColor.substring(4);
            return [
               parseInt(hex.substring(0, 2), 16),
               parseInt(hex.substring(2, 4), 16),
               parseInt(hex.substring(4, 6), 16),
            ];
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            return [
               parseInt(backendColor.substring(0, 2), 16),
               parseInt(backendColor.substring(2, 4), 16),
               parseInt(backendColor.substring(4, 6), 16),
            ];
         }
         return [0, 0, 0];
      };

      // Helper function to get column styling for dynamic format
      const getColumnStyles = (columnDefName) => {
         if (!isDynamicFormat || !formatData?.viewJson) {
            return {
               color: [0, 0, 0],
               fontStyle: 'normal',
               isBold: false,
               isItalic: false,
            };
         }

         const viewItem = formatData.viewJson.find((item) => item.defName === columnDefName);

         return {
            color: viewItem?.color ? convertBackendColor(viewItem.color) : [0, 0, 0],
            fontStyle: viewItem?.isBold ? 'bold' : 'normal',
            isBold: viewItem?.isBold === true || viewItem?.isBold === 'true',
            isItalic: viewItem?.isItalic === true || viewItem?.isItalic === 'true',
         };
      };

      // Define styles
      const styles = {
         header: {
            fillColor: [245, 245, 245],
            textColor: [0, 0, 0],
            fontStyle: 'bold',
         },
         companyHeader: {
            fillColor: [230, 230, 230],
            textColor: [125, 18, 20],
            fontStyle: 'bold',
         },
         partyHeader: {
            fillColor: [246, 240, 240],
            textColor: [42, 51, 53],
            fontStyle: 'bold',
         },
         oddRow: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
         },
         evenRow: {
            fillColor: [230, 242, 255],
            textColor: [0, 0, 0],
         },
         total: {
            fillColor: [230, 230, 230],
            textColor: [125, 18, 20],
            fontStyle: 'bold',
         },
      };

      // Function to format numbers - ensure string return
      const formatNumber = (num) => {
         if (num === null || num === undefined) return '-';
         return String(
            Number(num).toLocaleString('en-IN', {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
            }),
         );
      };

      // Function to format dates - ensure string return
      const formatDate = (dateStr) => {
         if (!dateStr) return '-';
         try {
            const date = new Date(dateStr);
            return String(date.toLocaleDateString('en-IN'));
         } catch (error) {
            return '-';
         }
      };

      // Track if we've drawn headers on the current page
      let headersDrawnOnPage = false;

      // Function to add a new page if needed
      const checkPageBreak = (heightNeeded = 10) => {
         if (currentY + heightNeeded > doc.internal.pageSize.getHeight() - 10) {
            doc.addPage('landscape');
            currentY = 10;
            headersDrawnOnPage = false; // Reset flag for new page
         }
      };

      // Calculate column positions and widths
      const calculateColumnLayout = () => {
         const columns = [];
         let xPos = margin;
         const availableWidth = pageWidth - margin * 2;

         if (isDynamicFormat && formatData?.viewJson) {
            // Dynamic format logic
            const sortedColumns = formatData.viewJson
               .filter((item) => item.isShow === true || item.isShow === 'true')
               .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));

            const totalFlex = sortedColumns.reduce((sum, col) => sum + (parseInt(col.flex) || 1), 0);

            sortedColumns.forEach((viewItem) => {
               const flexRatio = (parseInt(viewItem.flex) || 1) / totalFlex;
               const width = Math.floor(availableWidth * flexRatio);

               const fieldMapping = {
                  date: 'txndate',
                  'v.no.': 'docnumber',
                  due_days: 'dueDays',
                  net_amount: 'netAmount',
                  'rec._date': 'adjtxndate',
                  'rec._book': 'adjdaybookname',
                  'ret._adj._amt.': 'returnadjamount',
                  'adj._amt.': 'otheradjamount',
                  'os._amt': 'balanceamount',
               };

               const fieldId = fieldMapping[viewItem.defName] || viewItem.defName;

               columns.push({
                  id: fieldId,
                  defName: viewItem.defName,
                  header: viewItem.title || viewItem.defName,
                  x: xPos,
                  width: width,
                  align: ['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount', 'dueDays'].includes(
                     fieldId,
                  )
                     ? 'right'
                     : 'left',
                  styles: getColumnStyles(viewItem.defName),
               });

               xPos += width;
            });
         } else {
            // Static format logic
            visibleColumns.forEach((column) => {
               let width;
               switch (column.id) {
                  case 'txndate':
                     width = 22;
                     break;
                  case 'docnumber':
                     width = 18;
                     break;
                  case 'dueDays':
                     width = 14;
                     break;
                  case 'netAmount':
                     width = 25;
                     break;
                  case 'adjtxndate':
                     width = 22;
                     break;
                  case 'adjdaybookname':
                     width = 35;
                     break;
                  case 'returnadjamount':
                     width = 25;
                     break;
                  case 'otheradjamount':
                     width = 25;
                     break;
                  case 'balanceamount':
                     width = 25;
                     break;
                  default:
                     width = 20;
               }

               columns.push({
                  id: column.id,
                  header: column.header,
                  x: xPos,
                  width: width,
                  align: ['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount', 'dueDays'].includes(
                     column.id,
                  )
                     ? 'right'
                     : 'left',
                  styles: { color: [0, 0, 0], fontStyle: 'normal', isBold: false, isItalic: false },
               });

               xPos += width;
            });

            // Scale if needed for static format
            const totalWidth = columns.reduce((sum, col) => sum + col.width, 0);
            if (totalWidth > availableWidth) {
               const scaleFactor = availableWidth / totalWidth;
               let adjustedX = margin;

               columns.forEach((column) => {
                  column.width = Math.floor(column.width * scaleFactor);
                  column.x = adjustedX;
                  adjustedX += column.width;
               });
            }
         }

         return columns;
      };

      // Helper function to get cell value based on column ID
      const getCellValue = (transaction, columnId) => {
         let value;

         switch (columnId) {
            case 'txndate':
               value = formatDate(transaction.txndate);
               break;
            case 'docnumber':
               value = transaction.docnumber ? String(transaction.docnumber) : '-';
               break;
            case 'dueDays':
               value = transaction.dueDays != null ? String(transaction.dueDays) : '-';
               break;
            case 'netAmount':
               value = transaction.netAmount != null ? formatNumber(transaction.netAmount) : '-';
               break;
            case 'adjtxndate':
               value = transaction.adjtxndate ? formatDate(transaction.adjtxndate) : '-';
               break;
            case 'adjdaybookname':
               value = transaction.adjdaybookname ? String(transaction.adjdaybookname) : '-';
               break;
            case 'returnadjamount':
               value = transaction.returnadjamount != null ? formatNumber(transaction.returnadjamount) : '0.00';
               break;
            case 'otheradjamount':
               value = transaction.otheradjamount != null ? formatNumber(transaction.otheradjamount) : '0.00';
               break;
            case 'balanceamount':
               value = transaction.balanceamount != null ? formatNumber(transaction.balanceamount) : '-';
               break;
            default:
               // Handle any other field by converting to string
               value = transaction[columnId] != null ? String(transaction[columnId]) : '-';
               break;
         }

         // Final safety check - ensure the return value is always a string
         return String(value);
      };

      // Helper function to calculate totals based on visible columns
      const calculateTotals = (data, isCompany = false) => {
         let totals = {};
         const columns = calculateColumnLayout();

         columns.forEach((column) => {
            const columnId = column.id;

            if (['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount'].includes(columnId)) {
               if (isCompany) {
                  totals[columnId] = data.reduce((acc, accountData) => {
                     if (!accountData.data || !Array.isArray(accountData.data)) return acc;

                     if (columnId === 'netAmount' || columnId === 'balanceamount') {
                        const uniqueTransactions = accountData.data.filter(
                           (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                        );
                        return acc + uniqueTransactions.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                     } else {
                        return acc + accountData.data.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                     }
                  }, 0);
               } else {
                  if (columnId === 'netAmount' || columnId === 'balanceamount') {
                     const uniqueTransactions = data.filter(
                        (item, index, arr) => index === 0 || item.id !== arr[index - 1].id,
                     );
                     totals[columnId] = uniqueTransactions.reduce(
                        (sum, item) => sum + (Number(item[columnId]) || 0),
                        0,
                     );
                  } else {
                     totals[columnId] = data.reduce((sum, item) => sum + (Number(item[columnId]) || 0), 0);
                  }
               }
            }
         });

         return totals;
      };

      // Draw table headers
      const drawTableHeaders = () => {
         if (headersDrawnOnPage) return;

         const columns = calculateColumnLayout();
         const headerHeight = 8; // Reduced header height

         doc.setFillColor(...styles.header.fillColor);
         doc.setTextColor(...styles.header.textColor);
         doc.setFont(undefined, styles.header.fontStyle);
         doc.setFontSize(8); // Ensure header font size is 8

         doc.rect(margin, currentY, pageWidth - margin * 2, headerHeight, 'F');

         columns.forEach((column) => {
            doc.text(
               column.header,
               column.align === 'right' ? column.x + column.width - 1 : column.x + 1,
               currentY + headerHeight / 2 + 2, // Better vertical centering
               { align: column.align },
            );
         });

         currentY += headerHeight;
         headersDrawnOnPage = true;
      };

      // Check if we have data to process
      if (!salesReport || salesReport.length === 0) {
         alert('No data available for PDF generation.');
         return;
      }

      // Main rendering
      salesReport.forEach((companyData, companyIndex) => {
         checkPageBreak(15);

         const companyTotals = calculateTotals(companyData.data || [], true);
         const columns = calculateColumnLayout();

         // Company Header
         doc.setFillColor(...styles.companyHeader.fillColor);
         doc.setTextColor(...styles.companyHeader.textColor);
         doc.setFont(undefined, styles.companyHeader.fontStyle);
         doc.setFontSize(8); // Set font size to 8

         const companyHeaderHeight = 8; // Reduced height
         doc.rect(margin, currentY, pageWidth - margin * 2, companyHeaderHeight, 'F');
         doc.text(companyData.companyName || 'Unknown Company', margin + 2, currentY + 5);

         // Company totals
         let totalsText = '';
         columns.forEach((column) => {
            if (companyTotals[column.id] !== undefined) {
               const label =
                  column.id === 'netAmount'
                     ? 'Net'
                     : column.id === 'returnadjamount'
                        ? 'Ret.Adj'
                        : column.id === 'otheradjamount'
                           ? 'Adj'
                           : column.id === 'balanceamount'
                              ? 'Balance'
                              : '';
               if (label) {
                  totalsText += `${label}: ${formatNumber(companyTotals[column.id])}  `;
               }
            }
         });

         if (totalsText) {
            doc.text(totalsText, pageWidth - margin - 2, currentY + 5, { align: 'right' });
         }
         currentY += companyHeaderHeight; // Reduced spacing

         // Process accounts
         if (companyData.data && Array.isArray(companyData.data)) {
            companyData.data.forEach((accountData, accountIndex) => {
               checkPageBreak(12);

               const partyTotals = calculateTotals(accountData.data || []);

               // Party Header
               doc.setFillColor(...styles.partyHeader.fillColor);
               doc.setTextColor(...styles.partyHeader.textColor);
               doc.setFont(undefined, styles.partyHeader.fontStyle);
               doc.setFontSize(8); // Set font size to 8

               const partyHeaderHeight = 7; // Reduced height
               doc.rect(margin, currentY, pageWidth - margin * 2, partyHeaderHeight, 'F');
               doc.text(`Party: ${accountData.accountName || 'Unknown Party'}`, margin + 2, currentY + 4);

               // Party totals
               let partyTotalsText = 'Total: ';
               columns.forEach((column) => {
                  if (partyTotals[column.id] !== undefined) {
                     const label =
                        column.id === 'netAmount'
                           ? 'Net'
                           : column.id === 'returnadjamount'
                              ? 'Ret.Adj'
                              : column.id === 'otheradjamount'
                                 ? 'Adj'
                                 : column.id === 'balanceamount'
                                    ? 'Balance'
                                    : '';
                     if (label) {
                        partyTotalsText += `${label}: ${formatNumber(partyTotals[column.id])}  `;
                     }
                  }
               });

               doc.text(partyTotalsText, pageWidth - margin - 2, currentY + 4, { align: 'right' });
               currentY += partyHeaderHeight; // Reduced spacing

               // Draw table headers if not already drawn on this page
               drawTableHeaders();

               // Process transactions
               if (accountData.data && Array.isArray(accountData.data)) {
                  let rowIndex = 0;
                  accountData.data.forEach((transaction, transIndex) => {
                     checkPageBreak(7); // Reduced height needed check

                     const isOddRow = rowIndex % 2 !== 0;
                     const style = isOddRow ? styles.oddRow : styles.evenRow;

                     doc.setFillColor(...style.fillColor);
                     const rowHeight = 7; // Reduced row height
                     doc.rect(margin, currentY, pageWidth - margin * 2, rowHeight, 'F');

                     columns.forEach((column) => {
                        const value = getCellValue(transaction, column.id);

                        doc.setTextColor(...column.styles.color);
                        doc.setFont(
                           undefined,
                           column.styles.isBold ? 'bold' : column.styles.isItalic ? 'italic' : 'normal',
                        );
                        doc.setFontSize(8); // Ensure font size is 8

                        doc.text(
                           value,
                           column.align === 'right' ? column.x + column.width - 1 : column.x + 1,
                           currentY + rowHeight / 2 + 2, // Better vertical centering
                           { align: column.align },
                        );
                     });

                     currentY += rowHeight;
                     rowIndex++;
                  });
               }

               currentY += 3; // Reduced spacing between accounts
            });
         }

         currentY += 5; // Reduced spacing between companies
      });

      // Save the PDF
      doc.save('outstanding_report.pdf');
   }, [
      salesReport,
      datePartyWiseSalesRange,
      companyFilter,
      companyList,
      columnVisibility,
      reportType,
      dynamicOptions,
      columnsReportsSalesDetail,
      textColor,
   ]);

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find(db => db.id === viewDetail?.daybookId);
      if (entityType === 'purchasereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deletePurchaseReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'salereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
         }
         // deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'saleinvoice') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail?.daybookId,
               viewDetail?.accountId,
               deleteSaleInvoice,
               dispatch,
               storedCompanyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deleteSaleInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
      }
      if (entityType === 'purchaseinvoice') {
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deletePurchaseInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail.daybookId,
               viewDetail.accountId,
               deletePurchaseInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const storedCompanyId = localStorage.getItem('companyId');

   const renderDataRows = useCallback(
      (itemData, table, getCellStyles, formatData) => {
         if (!itemData || !Array.isArray(itemData)) return null;

         return itemData.map((transaction, rowIndex) => {
            const previousTransaction = rowIndex > 0 ? itemData[rowIndex - 1] : null;
            const isSameId = previousTransaction && transaction.id === previousTransaction.id;

            const viewJson = formatData?.viewJson || null;

            const isOddRow = rowIndex % 2 !== 0;
            rowIndex++;

            const handledata = async (data) => {
               const companyId = parseInt(storedCompanyId);
               setIsModalLoading(true); // Set loading state at the start

               try {
                  if (companyId === data.companyId && data.daybooktype === 20) {
                     setEntityType('receivemaster');
                     const response = await dispatch(getReceiveInventory(data.id));
                     await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
                     setIsOpenSingleViewinr(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 19) {
                     setEntityType('issuemaster');
                     const response = await dispatch(getIssueInventory(data.id));
                     await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
                     setIsOpenSingleViewinr(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 11) {
                     setEntityType('purchaseinvoice');
                     await dispatch(
                        getSinglePurchaseWithPrevAndNext({
                           id: data.id,
                           page: 1,
                           limit: 1,
                           sortBy: 'id',
                           sortOrder: 'desc',
                        }),
                     );
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 5) {
                     setEntityType('saleinvoice');
                     await dispatch(getSaleInvoice(data.id));
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 12) {
                     setEntityType('purchasereturn');
                     await dispatch(getSinglePurchaseReturn(data.id));
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 6) {
                     setEntityType('salereturn');
                     await dispatch(
                        getSingleSalesReturnWithPrevAndNext({
                           id: data.id,
                           page: 1,
                           limit: 1,
                           sortBy: 'id',
                           sortOrder: 'desc',
                        }),
                     );
                     setIsOpenPurchaseReturnSingleView(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 13) {
                     setEntityType('cash');
                     setIsBankPageTrue(false);
                     await dispatch(getOneVoucher(data.id));
                     setIsOpenSingleViewcnb(true);
                  }
                  if (companyId === data.companyId && data.daybooktype === 14) {
                     setEntityType('bank');
                     setIsBankPageTrue(true);
                     await dispatch(getOneVoucher(data.docid));
                     setIsOpenSingleViewcnb(true);
                  }
                  setTimeout(() => {
                     setIsModalLoading(false);
                  }, 100);
               } catch (error) {
                  console.error('Error loading single view data:', error);
                  setIsModalLoading(false); // Clear loading state on error
               }
            };

            const convertBackendColor = (backendColor) => {
               if (!backendColor) return null;
               if (backendColor.startsWith('#')) return backendColor;
               if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
               if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
               return backendColor;
            };

            if (formatData) {
               return (
                  <Tr
                     key={`row-${transaction.id || rowIndex}`}
                     borderBottom="1px solid #ccc"
                     bg={isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent'}
                     _dark={{ bg: isOddRow ? 'rgba(2, 14, 56, 0.7)' : 'transparent' }}
                     color={textColor}
                     onClick={() => handledata(transaction)}
                     cursor="pointer"
                     fontSize={'12px'}
                     fontWeight={500}
                     _hover={{ bg: '#e6f2ff' }}>
                     {viewJson
                        ?.filter((item) => item.isShow)
                        ?.map((item, index) => (
                           <Td
                              key={index}
                              py={2}
                              fontSize="12px"
                              fontWeight={item.isBold ? 'bold' : 'normal'}
                              fontStyle={item.isItalic ? 'italic' : 'normal'}
                              color={textColor}
                              textAlign={
                                 item.defName === 'os._amt' ||
                                    item.defName === 'net_amount' ||
                                    item.defName === 'ret._adj._amt.' ||
                                    item.defName === 'adj._amt.'
                                    ? 'right'
                                    : 'left'
                              }
                              textColor={convertBackendColor(item.color)}>
                              {item.defName === 'net_amount' && transaction.netAmount}
                              {item.defName === 'v.no.' && transaction.docnumber}
                              {item.defName === 'due_days' && transaction.dueDays !== null && transaction.dueDays !== 0
                                 ? transaction.dueDays
                                 : ''}
                              {item.defName === 'date' && new Date(transaction.txndate).toLocaleDateString('en-IN')}
                              {item.defName === 'rec._date' &&
                                 new Date(transaction.adjtxndate).toLocaleDateString('en-IN')}
                              {item.defName === 'rec._book' && transaction.adjdaybookname}
                              {item.defName === 'ret._adj._amt.' && transaction.returnadjamount}
                              {item.defName === 'adj._amt.' && transaction.otheradjamount}
                              {item.defName === 'os._amt' && transaction.balanceamount}
                           </Td>
                        ))}
                  </Tr>
               );
            } else {
               return (
                  <Tr
                     key={`row-${transaction.id || rowIndex}`}
                     borderBottom="1px solid #ccc"
                     bg={isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent'}
                     _dark={{ bg: isOddRow ? 'rgba(2, 14, 56, 0.7)' : 'transparent' }}
                     color={textColor}
                     onClick={() => handledata(transaction)}
                     cursor="pointer"
                     fontSize={'12px'}
                     fontWeight={500}
                     _hover={{ bg: '#e6f2ff' }}>
                     {table.getVisibleLeafColumns().map((column) => {
                        const columnId = column.id;
                        const isNumericColumn = [
                           'netAmount',
                           'dueDays',
                           'returnadjamount',
                           'otheradjamount',
                           'adjtxndate',
                           'adjdaybookname',
                           'balanceamount',
                        ].includes(columnId);

                        let cellContent = '-';
                        if (!isSameId || columnId === 'returnadjamount' || columnId === 'otheradjamount') {
                           switch (columnId) {
                              case 'txndate':
                                 cellContent = transaction.txndate
                                    ? new Date(transaction.txndate).toLocaleDateString('en-IN')
                                    : '-';
                                 break;
                              case 'docnumber':
                                 cellContent = transaction.docnumber || '-';
                                 break;
                              case 'dueDays':
                                 cellContent = transaction.dueDays || '-';
                                 break;
                              case 'netAmount':
                                 cellContent =
                                    transaction.netAmount != null
                                       ? Number(transaction.netAmount).toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })
                                       : '-';
                                 break;
                              case 'adjtxndate':
                                 cellContent = transaction.adjtxndate
                                    ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN')
                                    : '-';
                                 break;
                              case 'adjdaybookname':
                                 cellContent = transaction.adjdaybookname || '-';
                                 break;
                              case 'returnadjamount':
                                 cellContent =
                                    transaction.returnadjamount != null
                                       ? Number(transaction.returnadjamount).toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })
                                       : '00.00';
                                 break;
                              case 'otheradjamount':
                                 cellContent =
                                    transaction.otheradjamount != null
                                       ? Number(transaction.otheradjamount).toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })
                                       : '00.00';
                                 break;
                              case 'balanceamount':
                                 cellContent =
                                    transaction.balanceamount != null
                                       ? Number(transaction.balanceamount).toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })
                                       : '-';
                                 break;
                              default:
                                 cellContent = transaction[columnId] || '-';
                           }
                        }

                        const cellStyles =
                           typeof getCellStyles === 'function' ? getCellStyles(column.id) : getCellStyles;
                        // console.log("cellContent", cellContent, cellStyles);

                        return (
                           <Td
                              key={columnId}
                              fontSize="14px"
                              p={1}
                              {...cellStyles}
                              isNumeric={isNumericColumn}
                              textAlign={isNumericColumn ? 'right' : 'left'}>
                              {cellContent}
                           </Td>
                        );
                     })}
                  </Tr>
               );
            }
         });
      },
      [dispatch, user?.loginhistory?.companyId, textColor],
   );

   const renderReportContent = useCallback(() => {
      // Get dynamic column configuration
      const dynamicColumns = columnsReportsSalesDetail();
      const visibleColumns = dynamicColumns.filter((col) => col.isShow !== false);

      // Helper function to get column config by accessor
      const getColumnConfig = (accessor) => {
         return dynamicColumns.find((col) => col.accessor === accessor) || {};
      };

      // Helper function to check if column is visible
      const isColumnVisible = (accessor) => {
         const config = getColumnConfig(accessor);
         return config.isShow !== false;
      };

      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={visibleColumns.length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      if (!salesReport || salesReport.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={visibleColumns.length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No outstanding data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      if (dynamicValues && dynamicValues.includes(reportType)) {
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         const viewJson = selectedFormat?.formatData?.viewJson || [];
         const formatData = selectedFormat?.formatData;

         const formatDefName = selectedFormat?.formatData?.defName;

         // Check if it's a supported sales report type
         const isOutstandingDate = formatDefName === 'OutstandingDate' || formatDefName === 'OutstandingBroker';
         const isOutstandingParty = formatDefName === 'OutstandingParty';

         if (!isOutstandingDate && !isOutstandingParty) {
            return null;
         }

         const convertBackendColor = (backendColor) => {
            if (!backendColor) return null;
            if (backendColor.startsWith('#')) return backendColor;
            if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
            if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
            return backendColor;
         };

         // Function to get styles for any cell based on columnId
         const getCellStyles = (filedname) => {
            const Jsonfiled =
               filedname === 'txndate'
                  ? 'date'
                  : filedname === 'docnumber'
                     ? 'v.no.'
                     : filedname === 'dueDays'
                        ? 'due_days'
                        : filedname === 'netAmount'
                           ? 'net_amount'
                           : filedname === 'adjtxndate'
                              ? 'rec._date'
                              : filedname === 'adjdaybookname'
                                 ? 'rec._book'
                                 : filedname === 'returnadjamount'
                                    ? 'ret._adj._amt.'
                                    : filedname === 'otheradjamount'
                                       ? 'adj._amt.'
                                       : filedname === 'balanceamount'
                                          ? 'os._amt'
                                          : filedname;

            // const viewItem = formatData.viewJson.find(
            //    (item) => item.title?.toLowerCase() || item.defName?.toLowerCase(),
            // );

            const viewItem = formatData.viewJson.find((item) => item?.defName === Jsonfiled);

            // console.log('viewJson', viewItem);
            // console.log('filedname', filedname);

            return {
               color: viewItem?.color ? convertBackendColor(viewItem.color) : textColor,
               fontWeight: viewItem?.isBold ? 'bold' : 'normal',
               fontStyle: viewItem?.isItalic ? 'italic' : 'normal',
            };
         };

         const shouldShowColumn = (columnId) => {
            const columnsToHide = [];
            if (reportType === 'date') {
               columnsToHide.push('date');
            } else if (reportType === 'party') {
               columnsToHide.push('party', 'partyName');
            } else if (reportType === 'broker') {
               columnsToHide.push('broker', 'brokerName');
            }

            if (columnsToHide.includes(columnId)) {
               return false;
            }

            const viewItem = viewJson.find(
               (item) =>
                  item.defName?.toLowerCase() === columnId.toLowerCase() ||
                  item.title?.toLowerCase() === columnId.toLowerCase(),
            );

            if (viewItem) {
               return viewItem.isShow === true || viewItem.isShow === 'true';
            }

            return true;
         };

         // Calculate grand totals for the party report
         const calculatePartyGrandTotals = () => {
            return salesReport.reduce(
               (acc, companyData) => {
                  if (!companyData.data || !Array.isArray(companyData.data)) return acc;

                  const companyTotals = companyData.data.reduce(
                     (companyAcc, accountData) => {
                        if (!accountData.data || !Array.isArray(accountData.data)) return companyAcc;

                        const uniqueTransactions = accountData.data.filter((item, index, arr) => {
                           if (index === 0) return true;
                           return item.id !== arr[index - 1].id;
                        });

                        const accountNetTotal = uniqueTransactions.reduce(
                           (sum, item) => sum + (Number(item.netAmount) || 0),
                           0,
                        );
                        const accountReturnAdjTotal = accountData.data.reduce(
                           (sum, item) => sum + (Number(item.returnadjamount) || 0),
                           0,
                        );
                        const accountOtherAdjTotal = accountData.data.reduce(
                           (sum, item) => sum + (Number(item.otheradjamount) || 0),
                           0,
                        );
                        const accountBalanceTotal = uniqueTransactions.reduce(
                           (sum, item) => sum + (Number(item.balanceamount) || Number(item.netAmount) || 0),
                           0,
                        );

                        return {
                           netTotal: companyAcc.netTotal + accountNetTotal,
                           returnAdjTotal: companyAcc.returnAdjTotal + accountReturnAdjTotal,
                           otherAdjTotal: companyAcc.otherAdjTotal + accountOtherAdjTotal,
                           balanceTotal: companyAcc.balanceTotal + accountBalanceTotal,
                        };
                     },
                     { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
                  );

                  return {
                     netTotal: acc.netTotal + companyTotals.netTotal,
                     returnAdjTotal: acc.returnAdjTotal + companyTotals.returnAdjTotal,
                     otherAdjTotal: acc.otherAdjTotal + companyTotals.otherAdjTotal,
                     balanceTotal: acc.balanceTotal + companyTotals.balanceTotal,
                  };
               },
               { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
            );
         };

         // RENDER SALES DATE FORMAT
         if (isOutstandingDate) {
            return salesReport.map((dateItem, index) => (
               <React.Fragment key={`date-${dateItem.date || index}`}>
                  {dateItem.data &&
                     Array.isArray(dateItem.data) &&
                     dateItem.data.map((item, itemIndex) => {
                        const uniqueData =
                           item.data?.filter((d, idx, arr) => idx === 0 || d.id !== arr[idx - 1].id) || [];

                        const totals = {
                           netAmount: uniqueData.reduce((sum, d) => sum + (Number(d.netAmount) || 0), 0),
                           returnAdj: item.data?.reduce((sum, d) => sum + (Number(d.returnadjamount) || 0), 0) || 0,
                           otherAdj: item.data?.reduce((sum, d) => sum + (Number(d.otheradjamount) || 0), 0) || 0,
                           balanceAmount: uniqueData.reduce((sum, d) => sum + (Number(d.balanceamount) || 0), 0),
                        };

                        return (
                           <React.Fragment key={`item-${itemIndex}`}>
                              {item.data && renderDataRows(item.data, table, getCellStyles, formatData)}
                              <Tr>
                                 {formatData?.viewJson
                                    ?.filter((item) => item.isShow)
                                    ?.map((viewItem, index) => {
                                       return (
                                          <Td
                                             key={index}
                                             p="2px"
                                             py="3px"
                                             fontSize="14px"
                                             fontWeight="semibold"
                                             colSpan={1}
                                             textAlign={viewItem.defName !== 'date' ? 'right' : 'left'}
                                             textColor="brown">
                                             {viewItem.defName === 'date'
                                                ? 'Total :'
                                                : viewItem.defName === 'net_amount'
                                                   ? totals.netAmount.toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })
                                                   : viewItem.defName === 'ret._adj._amt.'
                                                      ? totals.returnAdj.toLocaleString('en-IN', {
                                                         minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2,
                                                      })
                                                      : viewItem.defName === 'adj._amt.'
                                                         ? totals.otherAdj.toLocaleString('en-IN', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                         })
                                                         : viewItem.defName === 'os._amt'
                                                            ? totals.balanceAmount.toLocaleString('en-IN', {
                                                               minimumFractionDigits: 2,
                                                               maximumFractionDigits: 2,
                                                            })
                                                            : ''}
                                          </Td>
                                       );
                                    })}
                              </Tr>
                              {/* <Tr>
                                 <Td
                                    p="2px"
                                    py="3px"
                                    fontSize="14px"
                                    fontWeight="semibold"
                                    colSpan={shouldShowColumn('netAmount') ? 3 : 1}
                                    textAlign="right"
                                    textColor="brown">
                                    Total :
                                 </Td>
                                 {shouldShowColumn('netAmount') && (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="14px"
                                       fontWeight="semibold"
                                       isNumeric
                                       textColor="brown"
                                       {...getCellStyles('netAmount')}>
                                       {totals.netAmount.toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })}
                                    </Td>
                                 )}
                                 {shouldShowColumn('netAmount') && <Td colSpan={2}></Td>}
                                 {shouldShowColumn('returnadjamount') && (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="14px"
                                       fontWeight="semibold"
                                       isNumeric
                                       textColor="brown"
                                       {...getCellStyles('returnadjamount')}>
                                       {totals.returnAdj.toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })}
                                    </Td>
                                 )}
                                 {shouldShowColumn('otheradjamount') && (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="14px"
                                       fontWeight="semibold"
                                       isNumeric
                                       textColor="brown"
                                       {...getCellStyles('otheradjamount')}>
                                       {totals.otherAdj.toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })}
                                    </Td>
                                 )}
                                 {shouldShowColumn('balanceamount') && (
                                    <Td
                                       p="2px"
                                       py="3px"
                                       fontSize="14px"
                                       fontWeight="semibold"
                                       isNumeric
                                       textColor="brown"
                                       {...getCellStyles('balanceamount')}>
                                       {totals.balanceAmount.toLocaleString('en-IN', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                       })}
                                    </Td>
                                 )}
                              </Tr> */}
                           </React.Fragment>
                        );
                     })}
               </React.Fragment>
            ));
         }

         // RENDER SALES PARTY FORMAT
         if (isOutstandingParty) {
            const grandTotals = calculatePartyGrandTotals();

            return (
               <>
                  {salesReport.map((companyData, companyIndex) => {
                     const companyKey = `company-${companyData.companyId || companyIndex}`;
                     const isCompanyExpanded = expandedItems[companyKey] !== false;

                     return (
                        <React.Fragment key={companyKey}>
                           {/* Company Header Row */}
                           <Tr bg="#E6E6E6" _dark={{ bg: 'gray.800' }}>
                              {formatData?.viewJson
                                 ?.filter((item) => item.isShow)
                                 ?.map((viewItem, index) => {
                                    const { defName } = viewItem;

                                    let cellValue = '';

                                    if (index === 0) {
                                       cellValue = companyData?.companyName || '';
                                    } else if (defName === 'net_amount') {
                                       cellValue =
                                          grandTotals?.netTotal?.toLocaleString('en-IN', {
                                             minimumFractionDigits: 2,
                                             maximumFractionDigits: 2,
                                          }) || '0.00';
                                    } else if (defName === 'ret._adj._amt.') {
                                       cellValue =
                                          grandTotals?.returnAdjTotal?.toLocaleString('en-IN', {
                                             minimumFractionDigits: 2,
                                             maximumFractionDigits: 2,
                                          }) || '0.00';
                                    } else if (defName === 'adj._amt.') {
                                       cellValue =
                                          grandTotals?.otherAdjTotal?.toLocaleString('en-IN', {
                                             minimumFractionDigits: 2,
                                             maximumFractionDigits: 2,
                                          }) || '0.00';
                                    } else if (defName === 'os._amt') {
                                       cellValue =
                                          grandTotals?.balanceTotal?.toLocaleString('en-IN', {
                                             minimumFractionDigits: 2,
                                             maximumFractionDigits: 2,
                                          }) || '0.00';
                                    }

                                    return (
                                       <Td
                                          key={index}
                                          p="2px"
                                          py="3px"
                                          fontSize="14px"
                                          fontWeight="semibold"
                                          colSpan={1}
                                          textAlign={defName !== 'date' ? 'right' : 'left'}
                                          textColor="brown">
                                          {cellValue}
                                       </Td>
                                    );
                                 })}

                              {/* <Td
                                 colSpan={3}
                                 p="2px"
                                 py="3px"
                                 fontSize="16px"
                                 fontWeight="bold"
                                 textColor={'#7D1214'}
                                 _dark={{ color: '#FFF' }}>
                                 <Flex align="center" justify="space-between">
                                    {companyData.companyName}
                                 </Flex>
                              </Td>
                              {shouldShowColumn('netAmount') && (
                                 <Td
                                    p="2px"
                                    py="5px"
                                    fontSize="15px"
                                    fontWeight="bold"
                                    isNumeric
                                    textColor={'#7D1214'}
                                    _dark={{ color: '#FFF' }}
                                    {...getCellStyles('netAmount')}>
                                    {grandTotals.netTotal.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {shouldShowColumn('returnadjamount') && (
                                 <Td
                                    p="2px"
                                    py="5px"
                                    fontSize="15px"
                                    colSpan={3}
                                    fontWeight="bold"
                                    isNumeric
                                    textColor={'#7D1214'}
                                    _dark={{ color: '#FFF' }}
                                    {...getCellStyles('returnadjamount')}>
                                    {grandTotals.returnAdjTotal.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {shouldShowColumn('otheradjamount') && (
                                 <Td
                                    p="2px"
                                    py="5px"
                                    fontSize="15px"
                                    fontWeight="bold"
                                    isNumeric
                                    textColor={'#7D1214'}
                                    _dark={{ color: '#FFF' }}
                                    {...getCellStyles('otheradjamount')}>
                                    {grandTotals.otherAdjTotal.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {shouldShowColumn('balanceamount') && (
                                 <Td
                                    p="2px"
                                    py="5px"
                                    fontSize="15px"
                                    fontWeight="bold"
                                    isNumeric
                                    textColor={'#7D1214'}
                                    _dark={{ color: '#FFF' }}
                                    {...getCellStyles('balanceamount')}>
                                    {grandTotals.balanceTotal.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                    <IconButton
                                       icon={isCompanyExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                       size="xs"
                                       onClick={() => toggleExpand(companyKey)}
                                       aria-label={isCompanyExpanded ? 'Collapse Company' : 'Expand Company'}
                                    />
                                 </Td>
                              )} */}
                           </Tr>

                           {isCompanyExpanded &&
                              companyData.data &&
                              Array.isArray(companyData.data) &&
                              companyData.data.map((accountData, accountIndex) => {
                                 const accountKey = `account-${accountData.accountId || accountIndex}`;
                                 const isAccountExpanded = expandedItems[accountKey] !== false;

                                 const uniqueTransactions = accountData.data
                                    ? accountData.data.filter((item, index, arr) => {
                                       if (index === 0) return true;
                                       return item.id !== arr[index - 1].id;
                                    })
                                    : [];

                                 const accountTotals = {
                                    netTotal: uniqueTransactions.reduce(
                                       (sum, item) => sum + (Number(item.netAmount) || 0),
                                       0,
                                    ),
                                    returnAdjTotal: accountData.data
                                       ? accountData.data.reduce(
                                          (sum, item) => sum + (Number(item.returnadjamount) || 0),
                                          0,
                                       )
                                       : 0,
                                    otherAdjTotal: accountData.data
                                       ? accountData.data.reduce(
                                          (sum, item) => sum + (Number(item.otheradjamount) || 0),
                                          0,
                                       )
                                       : 0,
                                    balanceTotal: uniqueTransactions.reduce(
                                       (sum, item) => sum + (Number(item.balanceamount) || Number(item.netAmount) || 0),
                                       0,
                                    ),
                                 };

                                 return (
                                    <React.Fragment key={`party-${accountData.accountId || accountIndex}`}>
                                       <Tr bg="#F6F0F0" color={textColor} _dark={{ bg: 'gray.700' }}>
                                          {formatData?.viewJson
                                             ?.filter((item) => item.isShow)
                                             ?.map((viewItem, index) => {
                                                const { defName } = viewItem;

                                                let cellValue = '';

                                                if (index === 0) {
                                                   cellValue = 'Party :' + accountData.accountName;
                                                } else if (defName === 'net_amount') {
                                                   cellValue =
                                                      accountTotals?.netTotal?.toLocaleString('en-IN', {
                                                         minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2,
                                                      }) || '0.00';
                                                } else if (defName === 'ret._adj._amt.') {
                                                   cellValue =
                                                      accountTotals?.returnAdjTotal?.toLocaleString('en-IN', {
                                                         minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2,
                                                      }) || '0.00';
                                                } else if (defName === 'adj._amt.') {
                                                   cellValue =
                                                      accountTotals?.otherAdjTotal?.toLocaleString('en-IN', {
                                                         minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2,
                                                      }) || '0.00';
                                                } else if (defName === 'os._amt') {
                                                   cellValue =
                                                      accountTotals?.balanceTotal?.toLocaleString('en-IN', {
                                                         minimumFractionDigits: 2,
                                                         maximumFractionDigits: 2,
                                                      }) || '0.00';
                                                } else if (index === 1) {
                                                   cellValue = 'Total :';
                                                }

                                                return (
                                                   <Td
                                                      key={index}
                                                      p="2px"
                                                      py="3px"
                                                      fontSize="14px"
                                                      fontWeight="semibold"
                                                      colSpan={1}
                                                      textAlign={defName !== 'date' ? 'right' : 'left'}
                                                      textColor="brown">
                                                      {cellValue}
                                                      {defName === 'os._amt' && (
                                                         <IconButton
                                                            icon={
                                                               isAccountExpanded ? (
                                                                  <ChevronDownIcon />
                                                               ) : (
                                                                  <ChevronUpIcon />
                                                               )
                                                            }
                                                            size="xs"
                                                            ml={2}
                                                            onClick={() => toggleExpand(accountKey)}
                                                            aria-label={isAccountExpanded ? 'Collapse' : 'Expand'}
                                                         />
                                                      )}
                                                   </Td>
                                                );
                                             })}
                                          {/* <Td p="2px" py="3px" fontSize="15px" fontWeight="bold" color={textColor}>
                                             <Flex align="center">Party : {accountData.accountName}</Flex>
                                          </Td>
                                          {shouldShowColumn('netAmount') && (
                                             <>
                                                <Td
                                                   p="2px"
                                                   py="3px"
                                                   fontSize="14px"
                                                   fontWeight="semibold"
                                                   colSpan={2}
                                                   textAlign="right">
                                                   Total :
                                                </Td>
                                                <Td
                                                   p="2px"
                                                   py="3px"
                                                   fontSize="15px"
                                                   fontWeight="semibold"
                                                   isNumeric
                                                   {...getCellStyles('netAmount')}>
                                                   {accountTotals.netTotal.toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })}
                                                </Td>
                                             </>
                                          )}
                                          {shouldShowColumn('returnadjamount') && <Td colSpan={2}></Td>}
                                          {shouldShowColumn('returnadjamount') && (
                                             <Td
                                                p="2px"
                                                py="3px"
                                                fontSize="15px"
                                                fontWeight="semibold"
                                                isNumeric
                                                {...getCellStyles('returnadjamount')}>
                                                {accountTotals.returnAdjTotal.toLocaleString('en-IN', {
                                                   minimumFractionDigits: 2,
                                                   maximumFractionDigits: 2,
                                                })}
                                             </Td>
                                          )}
                                          {shouldShowColumn('otheradjamount') && (
                                             <Td
                                                p="2px"
                                                py="3px"
                                                fontSize="15px"
                                                fontWeight="semibold"
                                                isNumeric
                                                {...getCellStyles('otheradjamount')}>
                                                {accountTotals.otherAdjTotal.toLocaleString('en-IN', {
                                                   minimumFractionDigits: 2,
                                                   maximumFractionDigits: 2,
                                                })}
                                             </Td>
                                          )}
                                          {shouldShowColumn('balanceamount') && (
                                             <Td
                                                p="2px"
                                                py="3px"
                                                fontSize="15px"
                                                fontWeight="semibold"
                                                isNumeric
                                                {...getCellStyles('balanceamount')}>
                                                {accountTotals.balanceTotal.toLocaleString('en-IN', {
                                                   minimumFractionDigits: 2,
                                                   maximumFractionDigits: 2,
                                                })}
                                                <IconButton
                                                   icon={isAccountExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                                   size="xs"
                                                   ml={2}
                                                   onClick={() => toggleExpand(accountKey)}
                                                   aria-label={isAccountExpanded ? 'Collapse' : 'Expand'}
                                                />
                                             </Td>
                                          )} */}
                                       </Tr>
                                       {isAccountExpanded &&
                                          accountData.data &&
                                          renderDataRows(accountData.data, table, getCellStyles, formatData)}
                                    </React.Fragment>
                                 );
                              })}
                        </React.Fragment>
                     );
                  })}
               </>
            );
         }

         return null;
      }

      if (reportType === REPORT_TYPE.party) {
         const grandTotals = salesReport.reduce(
            (acc, companyData) => {
               if (!companyData.data || !Array.isArray(companyData.data)) return acc;

               const companyTotals = companyData.data.reduce(
                  (companyAcc, accountData) => {
                     if (!accountData.data || !Array.isArray(accountData.data)) return companyAcc;

                     const uniqueTransactions = accountData.data.filter((item, index, arr) => {
                        if (index === 0) return true;
                        return item.id !== arr[index - 1].id;
                     });

                     const accountNetTotal = uniqueTransactions.reduce(
                        (sum, item) => sum + (Number(item.netAmount) || 0),
                        0,
                     );
                     const accountReturnAdjTotal = accountData.data.reduce(
                        (sum, item) => sum + (Number(item.returnadjamount) || 0),
                        0,
                     );
                     const accountOtherAdjTotal = accountData.data.reduce(
                        (sum, item) => sum + (Number(item.otheradjamount) || 0),
                        0,
                     );
                     const accountBalanceTotal = uniqueTransactions.reduce(
                        (sum, item) => sum + (Number(item.balanceamount) || Number(item.netAmount) || 0),
                        0,
                     );

                     return {
                        netTotal: companyAcc.netTotal + accountNetTotal,
                        returnAdjTotal: companyAcc.returnAdjTotal + accountReturnAdjTotal,
                        otherAdjTotal: companyAcc.otherAdjTotal + accountOtherAdjTotal,
                        balanceTotal: companyAcc.balanceTotal + accountBalanceTotal,
                     };
                  },
                  { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
               );

               return {
                  netTotal: acc.netTotal + companyTotals.netTotal,
                  returnAdjTotal: acc.returnAdjTotal + companyTotals.returnAdjTotal,
                  otherAdjTotal: acc.otherAdjTotal + companyTotals.otherAdjTotal,
                  balanceTotal: acc.balanceTotal + companyTotals.balanceTotal,
               };
            },
            { netTotal: 0, returnAdjTotal: 0, otherAdjTotal: 0, balanceTotal: 0 },
         );

         return (
            <>
               {salesReport.map((companyData, companyIndex) => {
                  const companyKey = `company-${companyData.companyId || companyIndex}`;
                  const isCompanyExpanded = expandedItems[companyKey] !== false;

                  return (
                     <React.Fragment key={companyKey}>
                        {/* Company Header Row */}
                        <Tr bg="#E6E6E6" _dark={{ bg: 'gray.800' }}>
                           <Td
                              colSpan={3}
                              p="2px"
                              py="3px"
                              fontSize="16px"
                              fontWeight="bold"
                              textColor={'#7D1214'}
                              _dark={{ color: '#FFF' }}>
                              <Flex align="center" justify="space-between">
                                 {companyData.companyName}
                              </Flex>
                           </Td>
                           {isColumnVisible('netAmount') && (
                              <Td
                                 p="2px"
                                 py="5px"
                                 fontSize="15px"
                                 fontWeight="bold"
                                 isNumeric
                                 textColor={'#7D1214'}
                                 _dark={{ color: '#FFF' }}>
                                 {grandTotals.netTotal.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 })}
                              </Td>
                           )}
                           {isColumnVisible('returnadjamount') && (
                              <Td
                                 p="2px"
                                 py="5px"
                                 fontSize="15px"
                                 colSpan={3}
                                 fontWeight="bold"
                                 isNumeric
                                 textColor={'#7D1214'}
                                 _dark={{ color: '#FFF' }}>
                                 {grandTotals.returnAdjTotal.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 })}
                              </Td>
                           )}
                           {isColumnVisible('otheradjamount') && (
                              <Td
                                 p="2px"
                                 py="5px"
                                 fontSize="15px"
                                 fontWeight="bold"
                                 isNumeric
                                 textColor={'#7D1214'}
                                 _dark={{ color: '#FFF' }}>
                                 {grandTotals.otherAdjTotal.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 })}
                              </Td>
                           )}
                           {isColumnVisible('balanceamount') && (
                              <Td
                                 p="2px"
                                 py="5px"
                                 fontSize="15px"
                                 fontWeight="bold"
                                 isNumeric
                                 textColor={'#7D1214'}
                                 _dark={{ color: '#FFF' }}>
                                 {grandTotals.balanceTotal.toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 })}
                                 <IconButton
                                    icon={isCompanyExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                    size="xs"
                                    onClick={() => toggleExpand(companyKey)}
                                    aria-label={isCompanyExpanded ? 'Collapse Company' : 'Expand Company'}
                                 />
                              </Td>
                           )}
                           {/* Add empty cells for other visible columns */}
                           {visibleColumns
                              .filter(
                                 (col) =>
                                    !['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount'].includes(
                                       col.accessor,
                                    ),
                              )
                              .map((col, idx) => (
                                 <Td key={`empty-${idx}`} p="2px" py="5px"></Td>
                              ))}
                        </Tr>

                        {isCompanyExpanded &&
                           companyData.data &&
                           Array.isArray(companyData.data) &&
                           companyData.data.map((accountData, accountIndex) => {
                              const accountKey = `account-${accountData.accountId || accountIndex}`;
                              const isAccountExpanded = expandedItems[accountKey] !== false;

                              const uniqueTransactions = accountData.data
                                 ? accountData.data.filter((item, index, arr) => {
                                    if (index === 0) return true;
                                    return item.id !== arr[index - 1].id;
                                 })
                                 : [];

                              const accountTotals = {
                                 netTotal: uniqueTransactions.reduce(
                                    (sum, item) => sum + (Number(item.netAmount) || 0),
                                    0,
                                 ),
                                 returnAdjTotal: accountData.data
                                    ? accountData.data.reduce(
                                       (sum, item) => sum + (Number(item.returnadjamount) || 0),
                                       0,
                                    )
                                    : 0,
                                 otherAdjTotal: accountData.data
                                    ? accountData.data.reduce(
                                       (sum, item) => sum + (Number(item.otheradjamount) || 0),
                                       0,
                                    )
                                    : 0,
                                 balanceTotal: uniqueTransactions.reduce(
                                    (sum, item) => sum + (Number(item.balanceamount) || Number(item.netAmount) || 0),
                                    0,
                                 ),
                              };

                              return (
                                 <React.Fragment key={`party-${accountData.accountId || accountIndex}`}>
                                    <Tr bg="#F6F0F0" color={textColor} _dark={{ bg: 'gray.700' }}>
                                       <Td p="2px" py="3px" fontSize="15px" fontWeight="bold" color={textColor}>
                                          <Flex align="center">Party : {accountData.accountName}</Flex>
                                       </Td>
                                       {isColumnVisible('netAmount') && (
                                          <>
                                             <Td
                                                p="2px"
                                                py="3px"
                                                fontSize="14px"
                                                fontWeight="semibold"
                                                colSpan={2}
                                                textAlign="right">
                                                Total :
                                             </Td>
                                             <Td p="2px" py="3px" fontSize="15px" fontWeight="semibold" isNumeric>
                                                {accountTotals.netTotal.toLocaleString('en-IN', {
                                                   minimumFractionDigits: 2,
                                                   maximumFractionDigits: 2,
                                                })}
                                             </Td>
                                          </>
                                       )}
                                       {isColumnVisible.returnadjamount && <Td colSpan={2}></Td>}
                                       {isColumnVisible.returnadjamount && (
                                          <Td p="2px" py="3px" fontSize="15px" fontWeight="semibold" isNumeric>
                                             {accountTotals.returnAdjTotal.toLocaleString('en-IN', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                             })}
                                          </Td>
                                       )}
                                       {isColumnVisible.otheradjamount && (
                                          <Td p="2px" py="3px" fontSize="15px" fontWeight="semibold" isNumeric>
                                             {accountTotals.otherAdjTotal.toLocaleString('en-IN', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                             })}
                                          </Td>
                                       )}
                                       {isColumnVisible.balanceamount && (
                                          <Td p="2px" py="3px" fontSize="15px" fontWeight="semibold" isNumeric>
                                             {accountTotals.balanceTotal.toLocaleString('en-IN', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                             })}
                                             <IconButton
                                                icon={isAccountExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                                size="xs"
                                                ml={2}
                                                onClick={() => toggleExpand(accountKey)}
                                                aria-label={isAccountExpanded ? 'Collapse' : 'Expand'}
                                             />
                                          </Td>
                                       )}
                                       {/* Add empty cells for other visible columns */}
                                       {visibleColumns
                                          .filter(
                                             (col) =>
                                                ![
                                                   'netAmount',
                                                   'returnadjamount',
                                                   'otheradjamount',
                                                   'balanceamount',
                                                ].includes(col.accessor),
                                          )
                                          .map((col, idx) => (
                                             <Td key={`empty-party-${idx}`} p="2px" py="3px"></Td>
                                          ))}
                                    </Tr>
                                    {isAccountExpanded && accountData.data && renderDataRows(accountData.data, table)}
                                 </React.Fragment>
                              );
                           })}
                     </React.Fragment>
                  );
               })}
            </>
         );
      } else {
         return salesReport.map((dateItem, index) => (
            <React.Fragment key={`date-${dateItem.date || index}`}>
               {dateItem.data &&
                  Array.isArray(dateItem.data) &&
                  dateItem.data.map((item, itemIndex) => {
                     const uniqueData = item.data?.filter((d, idx, arr) => idx === 0 || d.id !== arr[idx - 1].id) || [];

                     const totals = {
                        netAmount: uniqueData.reduce((sum, d) => sum + (Number(d.netAmount) || 0), 0),
                        returnAdj: item.data?.reduce((sum, d) => sum + (Number(d.returnadjamount) || 0), 0) || 0,
                        otherAdj: item.data?.reduce((sum, d) => sum + (Number(d.otheradjamount) || 0), 0) || 0,
                        balanceAmount: uniqueData.reduce((sum, d) => sum + (Number(d.balanceamount) || 0), 0),
                     };

                     return (
                        <React.Fragment key={`item-${itemIndex}`}>
                           {item.data && renderDataRows(item.data, table)}
                           <Tr>
                              <Td
                                 p="2px"
                                 py="3px"
                                 fontSize="14px"
                                 fontWeight="semibold"
                                 colSpan={isColumnVisible('netAmount') ? 3 : 1}
                                 textAlign="right"
                                 textColor="brown">
                                 Total :
                              </Td>
                              {isColumnVisible('netAmount') && (
                                 <Td p="2px" py="3px" fontSize="14px" fontWeight="semibold" isNumeric textColor="brown">
                                    {totals.netAmount.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {isColumnVisible('netAmount') && <Td colSpan={2}></Td>}
                              {isColumnVisible('returnadjamount') && (
                                 <Td p="2px" py="3px" fontSize="14px" fontWeight="semibold" isNumeric textColor="brown">
                                    {totals.returnAdj.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {isColumnVisible('otheradjamount') && (
                                 <Td p="2px" py="3px" fontSize="14px" fontWeight="semibold" isNumeric textColor="brown">
                                    {totals.otherAdj.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {isColumnVisible('balanceamount') && (
                                 <Td p="2px" py="3px" fontSize="14px" fontWeight="semibold" isNumeric textColor="brown">
                                    {totals.balanceAmount.toLocaleString('en-IN', {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                                 </Td>
                              )}
                              {/* Add empty cells for other visible columns */}
                              {visibleColumns
                                 .filter(
                                    (col) =>
                                       !['netAmount', 'returnadjamount', 'otheradjamount', 'balanceamount'].includes(
                                          col.accessor,
                                       ),
                                 )
                                 .map((col, idx) => (
                                    <Td key={`empty-total-${idx}`} p="2px" py="3px"></Td>
                                 ))}
                           </Tr>
                        </React.Fragment>
                     );
                  })}
            </React.Fragment>
         ));
      }
   }, [isLoading, salesReport, reportType, table, expandedItems, textColor, columnsReportsSalesDetail]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccount({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendIdInAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      console.log('account data', accountData, selectAcc);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({
         ...prev,
         id,
         ...rowData,
      }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Outstanding
               </Text>
            </Flex>
            <Flex gap={2}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: (selectedOptions) => setCompanyFilter(selectedOptions ? selectedOptions : []),
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           null,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} width={'150px'} fontSize={'13px'} fontWeight={500} mr={2}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        formatOptionLabel={formatOptionLabel}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={handleReportTypeChange}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              fontWeight: state.data?.isDynamic ? 'bold' : 'normal', // Style dynamic options differently
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           groupHeading: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} fontSize={'13px'} zIndex={3} fontWeight={500} display={{ base: 'none', lg: 'block' }}>
                     <label>Outstanding Type</label>
                     <Select
                        options={osTypeOptions}
                        value={osTypeOptions.find((option) => option.value === osType)}
                        onChange={(selectedOption) => setOsType(selectedOption.value)}
                        placeholder="Select Outstanding Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Flex alignItems="center">
                     <Box flex="1" mr={3}>
                        <MotionFlex
                           ref={wrapperRef}
                           align="center"
                           bg={bg}
                           borderRadius="full"
                           cursor="pointer"
                           px={expanded ? 3 : 0}
                           w={expanded ? '250px' : '40px'}
                           h="40px"
                           transition="all 0.3s ease"
                           onClick={() => setExpanded(true)}>
                           <MotionSearchIcon
                              color={icon}
                              animate={{ rotate: expanded ? 0 : 90 }}
                              transition={{ duration: 0.3 }}
                              style={{
                                 marginRight: expanded ? '8px' : '10px',
                                 marginLeft: expanded ? '0' : '10px',
                              }}
                           />
                           {expanded && (
                              <Input
                                 variant="unstyled"
                                 placeholder="Search ..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                       handleRefresh();
                                    }
                                 }}
                                 autoFocus
                                 color={icon}
                                 flex="1"
                              />
                           )}
                        </MotionFlex>
                     </Box>
                     <Button onClick={() => fetchData()} _hover={{ bg: 'blue.50' }} mr={2}>
                        <MdOutlineRefresh size={20} mr={2} />
                     </Button>

                     <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                        <IoFilterOutline size={22} />
                     </Button>

                     <Flex mr={2}>
                        <Tooltip label="Show/Hide Columns">
                           <IconButton
                              icon={<ViewIcon />}
                              onClick={() => setIsColumnSelectorOpen(true)}
                              aria-label="Column Visibility"
                           />
                        </Tooltip>
                     </Flex>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              />
                           </PopoverTrigger>
                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadAsExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px" />
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={handleDownloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px" />
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: (selectedOptions) =>
                                    setCompanyFilter(selectedOptions ? selectedOptions : []),
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => setReportType(selectedOption.value)}
                              placeholder="Select Report Type"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                              }}
                           />
                        </Box>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Outstanding Type</label>
                           <Select
                              options={osTypeOptions}
                              value={osTypeOptions.find((option) => option.value === osType)}
                              onChange={(selectedOption) => setOsType(selectedOption.value)}
                              placeholder="Select Outstanding Type"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                              }}
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={
                                 datePartyWiseSalesRange?.fromDate && datePartyWiseSalesRange?.toDate
                                    ? [
                                       new Date(datePartyWiseSalesRange.fromDate),
                                       new Date(datePartyWiseSalesRange.toDate),
                                    ]
                                    : null
                              }
                              onChange={handleDateRangeChange}
                              style={{ width: '100%', marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="hidden">
            <Card mt="15px" borderRadius="7px" overflow="hidden">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px" width="100%">
                     <Thead>
                        {dynamicOptionValues?.formatData?.viewJson ? (
                           <Tr>
                              {dynamicOptionValues.formatData.viewJson
                                 .filter((item) => item.isShow)
                                 .map((item, index) => {
                                    return (
                                       <Th
                                          key={index}
                                          borderColor={borderColor}
                                          cursor="pointer"
                                          px="12px"
                                          py="8px"
                                          fontSize="12px"
                                          bg="#F5F5F5"
                                          position="sticky"
                                          top="0"
                                          zIndex="1"
                                          whiteSpace="nowrap"
                                          borderTop="1px solid"
                                          borderBottom="1px solid"
                                          textAlign={item.defName === 'amt' ? 'right' : 'left'}>
                                          {item.title || item.defName}
                                       </Th>
                                    );
                                 })}
                           </Tr>
                        ) : (
                           table.getHeaderGroups().map((headerGroup) => (
                              <Tr key={headerGroup.id}>
                                 {headerGroup.headers.map((header) => {
                                    const columnDef = dynamicColumns.find((col) => col.id === header.column.id);
                                    const isNumericColumn = columnDef?.isNumeric;

                                    return (
                                       <Th
                                          key={header.id}
                                          colSpan={header.colSpan}
                                          borderColor={borderColor}
                                          cursor="pointer"
                                          px="12px"
                                          py="8px"
                                          fontSize="12px"
                                          bg="#F5F5F5"
                                          position="sticky"
                                          top="0"
                                          zIndex="1"
                                          isNumeric={isNumericColumn}
                                          whiteSpace="nowrap"
                                          onClick={header.column.getToggleSortingHandler()}
                                          borderTop="1px solid"
                                          borderBottom="1px solid">
                                          <Flex
                                             justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                             alignItems="center"
                                             gap="8px">
                                             {flexRender(header.column.columnDef.header, header.getContext())}
                                             {{
                                                asc: '↑',
                                                desc: '↓',
                                             }[header.column.getIsSorted()] ?? null}
                                          </Flex>
                                       </Th>
                                    );
                                 })}
                              </Tr>
                           ))
                        )}
                     </Thead>
                     <Tbody>{renderReportContent()}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         {isOpenPurchaseReturnSingleView && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : viewDetail ? (
                  <SalesDetails
                     isOpen={isOpenPurchaseReturnSingleView}
                     onClose={handleSalesDetailsClose}
                     singleEntityRights={
                        saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight
                     }
                     title={
                        entityType === 'saleinvoice'
                           ? 'Sales Invoice'
                           : entityType === 'salereturn'
                              ? 'Sales Return'
                              : entityType === 'purchaseinvoice'
                                 ? 'Purchase Invoice'
                                 : 'Purchase Return'
                     }
                     entityType={entityType}
                     singleEntity={viewDetail}
                     handlePrevPage={handlePrevPage}
                     handleNextPage={handleNextPage}
                     setIsEditFormOpen={setIsEditFormOpen}
                     setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
                     isEditFormOpen={isEditFormOpen}
                     // paginate={paginateData}
                     viewDetail={viewDetail}
                     lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.purchasereturnbillteams}
                     onDelete={deletePurchaseReturn}
                     handleSerchClose={() => {
                        console.log('');
                     }}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'OutstandingDate'}
            FixdefName2={'OutstandingParty'}
            FixdefName3={'OutstandingBroker'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            // initialIndex={initialIndex}
            // invoices={invoices}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />
         <AccountingReportsFilter
            type={reportType}
            osType={osType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            entityType="outstanding"
         />

         {updateFormLoading && formData.id && (
            <PaymentcaseFormEdit
               isOutstandingModalOpen={isOutstandingModalOpen}
               setIsOutstandingModalOpen={setIsOutstandingModalOpen}
               daybookTypeData={daybookTypeData}
               validationSchema={validationSchema}
               errors={errors}
               setErrors={setErrors}
               selectedAccount={selectedEditAccount}
               setSelectedAccount={setSelectedEditAccount}
               userData={accountData}
               type={13}
               isEditMode={true}
               receivedAmount={receivedAmount}
               setReceivedAmount={setReceivedAmount}
               totalPendingAccount={totalPendingAccount}
               setTotalPendingAccount={setTotalPendingAccount}
               formData={formData}
               setFormData={setFormData}
               transactionType={transactionType}
               handleClearData={handleClearData}
               pendingVoucher={pendingVoucher}
               setPendingVoucher={setPendingVoucher}
               currentPage={1}
               limit={10}
               companyId={companyId}
               sorting={sorting}
               pagination={10}
            />
         )}
         {isOpenSingleViewcnb && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : singleEntity ? (
                  <ViewSingleCashBankData
                     isOpenSingleView={isOpenSingleViewcnb}
                     onClose={() => setIsOpenSingleViewcnb(false)}
                     singleEntity={singleEntity}
                     formType="voucher"
                     isBankPageTrue={isBankPageTrue}
                     UserRights={(cashPaymentRight && cashReceiveRight) || (bankPaymentRight && bankReceiveRight)}
                     paymentRight={cashPaymentRight || bankPaymentRight}
                     receiveRight={cashReceiveRight || bankReceiveRight}
                     startEditing={(data) => startEditing(data.id, data)}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? deleteRecordForSales : deleteRecord}
            id={dataId}
            deleteApi={entityType === 'saleinvoice' ? deleteSaleInvoice : entityType === 'purchaseinvoice' ? deletePurchaseInvoice : entityType === 'salereturn' ? deleteSaleReturnInvoice : deletePurchaseReturnInvoice}
            dispatch={dispatch}
            type={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? "purchase" : "receive"}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default Outstanding;
